import "./Quote.css";

function Quote() {
  return <section>Quote Section!</section>;
}

export default Quote;
